import { twMerge } from 'src/utils/tw-merge.util'

type TKpiCardProps = Readonly<{
  label: string
  value: number
  colorClass: string
  bgColorClass?: string
  onClick?: () => void
  isActive?: boolean
}>

export const KpiCard = ({ label, value, colorClass, bgColorClass, onClick, isActive }: TKpiCardProps) => (
  <button
    type="button"
    className={twMerge(
      'c-flex c-flex-col c-items-center c-justify-center c-rounded-lg c-border c-border-grey-200 c-p-3 c-gap-0.5 c-bg-white',
      bgColorClass,
      onClick && 'c-cursor-pointer hover:c-border-grey-400 c-transition-colors',
      isActive && 'c-ring-2 c-ring-primary c-border-primary',
    )}
    onClick={onClick}
  >
    <span className={twMerge('c-text-2xl c-font-bold c-font-nexa', colorClass)}>{value}</span>
    <span className="c-text-xs c-text-grey-500 c-text-center">{label}</span>
  </button>
)
